import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, switchMap } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { ResultGoogle } from '../model/map-model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  constructor(
    private apiSrv: ApiService, 
    private httpClient:HttpClient
  ) {
  }

  getDirection(direction: string): Observable<any> {
    return this.googleMapsDinamicApi().pipe(
      switchMap((isLoaded) => {
        if (!isLoaded) {
          throw new Error('Google Maps API no se pudo cargar');
        }
        
        return new Observable<any>((observer) => {
          const geocoder = new (window as any).google.maps.Geocoder();
          
          geocoder.geocode(
            { address: direction },
            (results: any, status: any) => {
              if (status === 'OK' && results && results.length > 0) {
                // Transform the response to match the expected format
                const transformedResponse = {
                  status: 'OK',
                  results: results.map((result: any) => ({
                    geometry: {
                      location: {
                        lat: result.geometry.location.lat(),
                        lng: result.geometry.location.lng()
                      }
                    },
                    formatted_address: result.formatted_address,
                    place_id: result.place_id,
                    address_components: result.address_components
                  }))
                };
                observer.next(transformedResponse);
                observer.complete();
              } else {
                observer.error(`Geocoding failed: ${status}`);
              }
            }
          );
        });
      }),
      catchError((error) => {
        console.error('Error en getDirection:', error);
        throw error;
      })
    );
  }

  getDirectionWithCordinates(lat: number, long: number): Observable<any> {
    return this.googleMapsDinamicApi().pipe(
      switchMap((isLoaded) => {
        if (!isLoaded) {
          throw new Error('Google Maps API no se pudo cargar');
        }
        
        return new Observable<any>((observer) => {
          const geocoder = new (window as any).google.maps.Geocoder();
          const latlng = new (window as any).google.maps.LatLng(lat, long);
          
          geocoder.geocode(
            { location: latlng },
            (results: any, status: any) => {
              if (status === 'OK' && results && results.length > 0) {
                // Transform the response to match the expected format
                const transformedResponse = {
                  status: 'OK',
                  results: results.map((result: any) => ({
                    geometry: {
                      location: {
                        lat: result.geometry.location.lat(),
                        lng: result.geometry.location.lng()
                      }
                    },
                    formatted_address: result.formatted_address,
                    place_id: result.place_id,
                    address_components: result.address_components
                  }))
                };
                observer.next(transformedResponse);
                observer.complete();
              } else {
                observer.error(`Geocoding failed: ${status}`);
              }
            }
          );
        });
      }),
      catchError((error) => {
        console.error('Error en getDirectionWithCordinates:', error);
        throw error;
      })
    );
  }

  googleMapsDinamicApi(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      // Verificar si Google Maps ya está cargado
      if (typeof (window as any).google !== 'undefined' && (window as any).google.maps) {
        observer.next(true);
        observer.complete();
        return;
      }

      // Crear el script de Google Maps
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.keyGoogle}&libraries=places`;
      script.async = true;
      script.defer = true;

      // Evento de éxito
      script.onload = () => {
        observer.next(true);
        observer.complete();
      };

      // Evento de error
      script.onerror = () => {
        observer.error('Error al cargar Google Maps API');
      };

      // Agregar el script al DOM
      document.head.appendChild(script);
    }).pipe(
      catchError((error) => {
        console.error('Error cargando Google Maps:', error);
        return of(false);
      })
    );
  }
}


